import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from '../styles/components/price-form.scss';
import ClearFilter from './clear-filter';
// Validation with REGEX
const rxLive = /^\d*(?:[.,]\d*)?$/;
class PriceForm extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
        this.state = {
            price_min: '',
            price_max: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const { target } = event;
        const { name, value } = target;
        if (rxLive.test(value)) {
            this.setState({
                [name]: value,
            });
        }
    }

    handleSubmit() {
        this.props.submit(this.state.price_min, this.state.price_max, this.props.location);
    }

    render() {
        return (
            <div className="row" style={{ marginLeft: 15, paddingTop: 5 }}>
                <div className="col-xs-3 col-sm-4 col-md-4" style={{ padding: 0, marginRight: 0 }}>
                    <div className="input-group">
                        <span className={`input-group-addon ${styles.addon}`}>$</span>
                        <input
                            type="text"
                            className={`form-control ${styles.inputField}`}
                            name="price_min"
                            placeholder="Min"
                            inputMode="numeric"
                            value={this.state.price_min}
                            onChange={this.handleInputChange}
                        />
                    </div>
                </div>
                <div className="col-xs-3 col-sm-4 col-md-4" style={{ padding: 0, marginLeft: 0, borderRadius: 0 }}>
                    <div className="input-group">
                        <span className={`input-group-addon ${styles.addon}`}>$</span>
                        <input
                            type="text"
                            className={`form-control ${styles.inputField}`}
                            name="price_max"
                            placeholder="Max"
                            inputMode="numeric"
                            value={this.state.price_max}
                            onChange={this.handleInputChange}
                        />
                    </div>
                </div>
                <div className="col-xs-2 col-sm-4 col-md-2" style={{ paddingLeft: 0, marginLeft: 0, borderRadius: 0 }}>
                    <button
                        type="button"
                        className={`btn btn-xs ${styles.btnPrice}`}
                        onClick={this.handleSubmit}
                    >
                        <FormattedMessage id="go" defaultMessage="Go!" />
                    </button>
                </div>
                <ClearFilter
                    title={<FormattedMessage id="clear-filter" defaultMessage="Clear Filter" />}
                    setParams={this.props.setParams}
                />
            </div>
        );
    }
}

export default injectIntl(PriceForm);



/** WEBPACK FOOTER **
 ** ./src/components/shared/price-form.jsx
 **/